import React from 'react';
import {uniqueId} from 'lodash'
import axios from 'axios'

const CHUNK_SIZE = 1024 * 100;
const BASE_URL = 'https://datasets.recondex.se/upload/';

export default class UploadBtn extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      uploading:false,
      uploaded:false,
      percentage:0,
    };
    this.id = uniqueId('uploadBtn');
  }

  readFileChunk(file,chunkIndex) {
    return new Promise((resolve,reject) => {
      const start = chunkIndex * CHUNK_SIZE;
      const stop = start + CHUNK_SIZE;
      const blob = file.slice(start, stop);
      let reader = new FileReader();
      reader.onloadend = () => resolve(blob);
      reader.onerror = reject;
      reader.readAsBinaryString(blob);
    });
  }

  uploadFileChunk(file, chunkBlob) {
    return new Promise((resolve,reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open("POST", BASE_URL+'put?key=' + (file.uploadKey || ''), true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status !== 200) {
            reject(xhr.response);
          } else {
            const response = JSON.parse(xhr.response);
            if (!file.uploadKey) {
              file.uploadKey = response.key;
            }
            resolve(response);
          }
        }
      };
      xhr.send(chunkBlob);
    });
  }

  finishUpload(file) {
    return axios
      .post(BASE_URL+'finish?key='+file.uploadKey+'&name='+file.name)
      .then(response => this.props.onChange(response.data.filepath));
  }

  async readAndUploadFile(file) {
    this.setState({uploading:true});
    const numberOfChunks = Math.ceil(file.size / CHUNK_SIZE);
    let currentChunk = 0;
    while (currentChunk < numberOfChunks) {
      const chunkBlob = await this.readFileChunk(file,currentChunk);
      await this.uploadFileChunk(file, chunkBlob);
      currentChunk++;
      this.setState({percentage: Math.round(currentChunk/numberOfChunks*100)});
    }
    await this.finishUpload(file);
    this.setState({uploading:false,uploaded:true});
  }

  render() {
    let label = this.props.chooseFileLabel || 'Välj vil';
    if (this.state.uploaded) {
      label = this.props.changeFileLabel || 'Ändra fil';
    }
    if (this.state.uploading) {
      label = this.props.uploadingFileLabel || 'Vänta. Laddar upp filen ('+this.state.percentage+'%)..';
    }

    return (
      <div>
        <input
          type="file"
          id={this.id}
          style={{display:'none'}}
          onChange={e => e.target.files.length ? this.readAndUploadFile(e.target.files[0]) : null}
          />
        <label
          className="btn btn-default btn-block mb-3"
          htmlFor={this.id}
          >
            {label}
          </label>
      </div>
    );
  }

}
